import {NotificationsScreen} from './commons/notifications';
import {ProfileScreen} from './commons/profile';

export {NotificationsScreen, ProfileScreen};
